import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "condition-form__label" };
const _hoisted_2 = { class: "condition-form__form" };
const _hoisted_3 = { class: "condition-form__container" };
const _hoisted_4 = {
    key: 0,
    class: "condition-form__filter"
};
const _hoisted_5 = { class: "condition-form__buttons" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["onClick"];
import { computed, inject } from 'vue';
import { useStore } from 'vuex';
import { useAudienceManager } from '@/features/AudienceManager/composables/useAudienceManager';
import ConditionCriteria from '@/features/AudienceManager/components/Stages/Composition/BuilderInputs/ConditionCriteria.vue';
import ConditionValue from '@/features/AudienceManager/components/Stages/Composition/BuilderInputs/ConditionValue.vue';
import ConditionOperator from '@/features/AudienceManager/components/Stages/Composition/BuilderInputs/ConditionOperator.vue';
import i18n from '@/i18n';
import { useConditionValidator } from '@/features/AudienceManager/composables/useConditionValidator';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceConditionForm',
    setup(__props) {
        const store = useStore();
        const groupIndex = inject('groupIndex');
        const isInclude = inject('isInclude');
        const groupType = inject('groupType');
        const { isCreationMode, draftCondition, selectedCriteriaDetails, allCriteriaOptions } = useAudienceManager(isInclude, groupIndex);
        const { validateCondition } = useConditionValidator();
        const isConditionEditMode = computed(() => store.getters['audienceManager/isConditionEditMode']);
        const canEditCondition = computed(() => isConditionEditMode.value && isCreationMode.value);
        const hasFilterCondition = computed(() => Boolean(selectedCriteriaDetails.value?.filter));
        const shouldDisplayValueInput = computed(() => {
            const operator = draftCondition.value?.operator;
            const isNullOperator = operator && ['isnull', 'notnull'].includes(operator);
            return !isNullOperator;
        });
        const actionButtonText = computed(() => (isConditionEditMode.value ? i18n.global.t('update') : i18n.global.t('add')));
        const saveCondition = () => {
            if (!draftCondition.value?.column)
                return;
            const isValid = validateCondition(draftCondition.value, allCriteriaOptions.value);
            store.commit('audienceManager/SET_CONDITION_VALIDITY', {
                groupType,
                groupIndex,
                isValid,
            });
            if (!isValid)
                return;
            store.dispatch('audienceManager/saveCondition', {
                groupType,
                groupIndex,
                isConditionEditMode: isConditionEditMode.value,
            });
            resetConditionForm(groupType, groupIndex);
        };
        const resetConditionForm = (groupType, groupIndex) => {
            clearConditionValidity(groupType, groupIndex);
            clearSelectedCriteria();
            resetEditingCondition();
            clearEditingConditionMode();
            closeConditionForm();
        };
        const clearConditionValidity = (groupType, groupIndex) => {
            store.commit('audienceManager/CLEAR_CONDITION_VALIDITY', { groupType, groupIndex });
        };
        const clearSelectedCriteria = () => {
            store.dispatch('audienceManager/updateSelectedCriteria', {
                criteriaKey: null,
                groupType,
                groupIndex,
            });
        };
        const resetEditingCondition = () => {
            const emptyQueryCondition = {
                column: '',
                operator: '',
                value: [],
                referenceObjects: {},
                f_operator: '',
                f_value: [],
                f_type: '',
            };
            store.dispatch('audienceManager/setEditingCondition', {
                groupType,
                groupIndex,
                draftCondition: emptyQueryCondition,
            });
        };
        const clearEditingConditionMode = () => {
            store.dispatch('audienceManager/clearEditingConditionMode');
        };
        const closeConditionForm = () => {
            store.dispatch('audienceManager/toggleConditionForm', {
                isVisible: false,
                groupIndex,
            });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["condition-form", `condition-form--${_unref(groupIndex)}`])
            }, [
                _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.$t('audiences.add-serie')), 1),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (_openBlock(), _createBlock(ConditionCriteria, {
                            key: `criteria-${_unref(groupType)}-${_unref(groupIndex)}`,
                            class: "condition-form__criteria"
                        })),
                        _withDirectives(_createVNode(ConditionOperator, { "is-filter-mode": false }, null, 512), [
                            [_vShow, !hasFilterCondition.value]
                        ]),
                        _withDirectives(_createVNode(ConditionValue, {
                            class: _normalizeClass([{ 'condition-form__value--empty': !shouldDisplayValueInput.value }, "condition-form__value"]),
                            "is-filter-mode": false
                        }, null, 8, ["class"]), [
                            [_vShow, shouldDisplayValueInput.value]
                        ])
                    ]),
                    (hasFilterCondition.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(ConditionOperator, { "is-filter-mode": true }),
                            _createVNode(ConditionValue, { "is-filter-mode": true })
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("button", {
                            class: "btn btn-primary",
                            onClick: _withModifiers(saveCondition, ["prevent"])
                        }, _toDisplayString(actionButtonText.value), 9, _hoisted_6),
                        (canEditCondition.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-secondary",
                                onClick: _withModifiers(resetConditionForm, ["prevent"])
                            }, _toDisplayString(_ctx.$t('cancel')), 9, _hoisted_7))
                            : _createCommentVNode("", true)
                    ])
                ])
            ], 2));
        };
    }
});
